import { useEffect } from "react";

export const fixTextAreaHeight = (...args: Array<HTMLTextAreaElement | null>) => {
    if (args.length) {
        args.forEach((area) => {
            area && (area.style.height = area.scrollHeight + "px");
        });
    }
};

export const MODAL_AWAIT_DELAY = 200;

export function useTextAreaAutoHeight() {
    let textarea: HTMLTextAreaElement | null = null;

    // Тело в скобках, а не выражением: присваивание возвращает значение, а React 19
    // считает всё возвращённое из ref-колбэка функцией очистки и зовёт при размонтировании
    const oldRef = (value: HTMLTextAreaElement | null) => {
        textarea = value;
    };

    useEffect(() => {
        setTimeout(() => fixTextAreaHeight(textarea), MODAL_AWAIT_DELAY);
    });

    return oldRef;
}
